import useSWR from 'swr'

interface Coupon {
  extended: any
  isAvailable: boolean
  message: string
}

interface CouponResponse {
  coupon: Coupon
  status: string
}

const fetcher = (thcode: string, influencerActivationCode: string = '') => (url) => {
  const formData = new URLSearchParams()
  formData.append('coupon_code', thcode)
  formData.append('influencer_activation_code', influencerActivationCode)

  const requestOptions = {
    body: formData,
    method: 'POST',
  }

  return fetch(url, requestOptions).then(r => r.json())
}

export const useCoupon = (
  thcode: string = '',
  influencerActivationCode: string = '',
) => useSWR<CouponResponse, any>('/c/index/coupon', fetcher(thcode, influencerActivationCode))
